import { render, staticRenderFns } from "./AccountFranchisorLayout.vue?vue&type=template&id=45e33c80&scoped=true&"
import script from "./AccountFranchisorLayout.vue?vue&type=script&lang=js&"
export * from "./AccountFranchisorLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountFranchisorLayout.vue?vue&type=style&index=0&id=45e33c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e33c80",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountFranchisorMobileMenu: require('/home/circleci/repo/components/account-franchisor/menu/AccountFranchisorMobileMenu.vue').default,AccountFranchisorDesktopMenu: require('/home/circleci/repo/components/account-franchisor/menu/AccountFranchisorDesktopMenu.vue').default})
